(() => {
  const CONTRACTIONS = {
    "where's": 'where is',
    "what's": 'what is',
    "how's": 'how is',
    "when's": 'when is',
    "who's": 'who is',
    "it's": 'it is',
    "that's": 'that is',
    "there's": 'there is',
    "can't": 'cannot',
    "won't": 'will not',
    "don't": 'do not',
    "doesn't": 'does not',
    "didn't": 'did not',
    "isn't": 'is not',
    "aren't": 'are not',
    "wasn't": 'was not',
    "weren't": 'were not',
    "hasn't": 'has not',
    "haven't": 'have not',
    "hadn't": 'had not',
    "shouldn't": 'should not',
    "wouldn't": 'would not',
    "couldn't": 'could not',
    "i've": 'i have',
    "i'm": 'i am',
    "i'll": 'i will',
    "i'd": 'i would',
    "you've": 'you have',
    "you're": 'you are',
    "we've": 'we have',
    "they've": 'they have',
  };

  const normalizeText = (text) => {
    let normalized = (text || '').toLowerCase().replace(/[‘’]/g, "'");
    Object.keys(CONTRACTIONS).forEach((contraction) => {
      normalized = normalized.split(contraction).join(CONTRACTIONS[contraction]);
    });
    normalized = normalized.replace(/'/g, '');
    return normalized;
  };

  const SYNONYM_GROUPS = [
    ['broken', 'faulty', 'fault', 'damaged', 'damage', 'not working', "doesn't work", 'stopped working'],
    ['return', 'send back', 'refund', 'money back', 'exchange', 'swap'],
    ['missing', 'lost', 'not received', "haven't received", "hasn't arrived", "didn't arrive", 'never arrived'],
    ['late', 'delayed', 'delay', 'taking long', 'taking ages', 'slow'],
    ['track', 'tracking', 'where is my order', 'wismo', 'order status'],
    ['cancel', 'cancelled', 'cancellation', 'change my order', 'amend'],
    ['assemble', 'assembly', 'build', 'construct', 'put together', 'instructions'],
    ['clean', 'cleaning', 'wash', 'washing', 'washable'],
    ['size', 'sizing', 'fit', 'fits', 'measurements', 'dimensions'],
    ['safe', 'safety', 'standard', 'certified', 'certification'],
    ['warranty', 'guarantee', 'covered', 'cover'],
    ['parts', 'spares', 'spare parts', 'spare part', 'replacement part'],
    ['pod', 'nest', 'sleepyhead', 'positioner', 'insert'],
    ['weight', 'kg', 'kilos', 'pounds', 'lbs', 'heavy'],
    ['age', 'months', 'how long', 'outgrow'],
    ['password', 'login', 'log in', 'sign in', 'account access'],
    ['stock', 'sold out', 'out of stock', 'restock', 'notify me', 'back in stock'],
    ['trade', 'wholesale', 'bulk', 'business account'],
    ['press', 'media', 'influencer', 'collaboration', 'pr'],
    ['second-hand', 'secondhand', 'used', 'pre-owned', 'resale', 'resell'],
    ['mattress', 'protector'],
    ['sheets', 'bedding', 'fitted sheet'],
    ['bed', 'divan', 'ottoman', 'framed', 'strap'],
    ['rock', 'rocking', 'reflux', 'incline', 'tilt'],
    ['battery', 'batteries'],
    ['address', 'delivery address', 'shipping address'],
    ['price', 'cost', 'how much'],
    ['register', 'registration'],
  ].map((group) => group.map(normalizeText));

  const expandSearchTerms = (query) => {
    const normalizedQuery = normalizeText(query);
    const terms = new Set([normalizedQuery]);
    SYNONYM_GROUPS.forEach((group) => {
      const groupMatches = group.some((term) => term.includes(normalizedQuery) || normalizedQuery.includes(term));
      if (groupMatches) {
        group.forEach((term) => terms.add(term));
      }
    });
    return Array.from(terms);
  };

  const initHelpHub = () => {
    const root = document.getElementById('help-hub');
    if (!root) return;

    const grid = document.getElementById('help-hub-grid');
    const panels = root.querySelectorAll('[data-topic-panel]');
    const searchInput = document.getElementById('help-hub-search-input');
    const searchClear = root.querySelector('.help-hub__search-clear');
    const searchResults = document.getElementById('help-hub-search-results');
    const searchList = searchResults ? searchResults.querySelector('.help-hub__search-list') : null;
    const searchEmpty = searchResults ? searchResults.querySelector('.help-hub__search-empty') : null;

    const showGrid = () => {
      panels.forEach((panel) => { panel.hidden = true; });
      if (searchResults) searchResults.hidden = true;
      if (grid) grid.hidden = false;
    };

    const showPanel = (handle) => {
      const panel = root.querySelector(`[data-topic-panel="${handle}"]`);
      if (!panel) return;
      panels.forEach((p) => { p.hidden = true; });
      if (grid) grid.hidden = true;
      if (searchResults) searchResults.hidden = true;
      panel.hidden = false;
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.pushState) {
        history.pushState(null, '', `#${handle}`);
      } else {
        window.location.hash = handle;
      }
    };

    root.querySelectorAll('[data-topic-open]').forEach((el) => {
      el.addEventListener('click', () => showPanel(el.getAttribute('data-topic-open')));
    });

    root.querySelectorAll('[data-topic-back]').forEach((el) => {
      el.addEventListener('click', () => {
        showGrid();
        if (history.pushState) history.pushState(null, '', window.location.pathname);
      });
    });

    const openFromHash = () => {
      const handle = window.location.hash.replace('#', '');
      if (handle && root.querySelector(`[data-topic-panel="${handle}"]`)) {
        showPanel(handle);
      } else {
        showGrid();
      }
    };
    window.addEventListener('hashchange', openFromHash);
    openFromHash();

    root.querySelectorAll('.help-hub__faq-item .item-header').forEach((header) => {
      header.addEventListener('click', () => {
        header.parentNode.classList.toggle('open');
      });
    });

    root.querySelectorAll('[data-quickest-fix-form]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        const destination = form.getAttribute('data-destination');
        if (!destination) {
          e.preventDefault();
          return;
        }
        const hasFileInput = form.querySelector('input[type="file"]');
        if (hasFileInput && hasFileInput.files.length > 0) {
          e.preventDefault();
          window.open(destination, '_blank', 'noopener');
        }
      });
    });

    if (searchInput && searchResults && searchList) {
      const allFaqItems = Array.from(root.querySelectorAll('[data-faq-item]')).map((item) => {
        const panel = item.closest('[data-topic-panel]');
        const productFaqGroup = item.closest('[data-product-faq-group]');
        let topicTitle = '';
        if (panel) {
          topicTitle = panel.querySelector('.help-hub__panel-title').textContent;
        } else if (productFaqGroup) {
          topicTitle = productFaqGroup.getAttribute('data-group-label') || '';
        }
        return {
          el: item,
          question: normalizeText(item.getAttribute('data-question') || ''),
          searchText: normalizeText((item.textContent || '').replace(/\s+/g, ' ').trim()),
          topicHandle: panel ? panel.getAttribute('data-topic-panel') : '',
          topicTitle: topicTitle,
        };
      });

      const runSearch = () => {
        const query = searchInput.value.trim();

        if (searchClear) searchClear.hidden = !query;

        if (!query) {
          searchResults.hidden = true;
          showGrid();
          return;
        }

        panels.forEach((p) => { p.hidden = true; });
        if (grid) grid.hidden = true;
        searchResults.hidden = false;

        const searchTerms = expandSearchTerms(query);
        const inQuestion = (item) => searchTerms.some((term) => item.question.includes(term));
        const matches = allFaqItems
          .filter((item) => searchTerms.some((term) => item.searchText.includes(term)))
          .sort((a, b) => (inQuestion(a) ? 0 : 1) - (inQuestion(b) ? 0 : 1));
        searchList.innerHTML = '';

        if (matches.length === 0) {
          if (searchEmpty) searchEmpty.hidden = false;
        } else {
          if (searchEmpty) searchEmpty.hidden = true;
          matches.forEach((match) => {
            const clone = match.el.cloneNode(true);
            clone.classList.add('open');
            clone.querySelector('.item-header').insertAdjacentHTML(
              'afterbegin',
              `<span class="help-hub__search-result-topic">${match.topicTitle}</span>`
            );
            clone.querySelector('.item-header').addEventListener('click', () => {
              clone.classList.toggle('open');
            });
            searchList.appendChild(clone);
          });
        }
      };

      let debounceTimer;
      searchInput.addEventListener('input', () => {
        if (searchClear) searchClear.hidden = !searchInput.value;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(runSearch, 150);
      });

      if (searchClear) {
        searchClear.addEventListener('click', () => {
          searchInput.value = '';
          searchClear.hidden = true;
          searchResults.hidden = true;
          showGrid();
          searchInput.focus();
        });
      }
    }

    root.querySelectorAll('[data-gorgias-chat-open]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
          window.GorgiasChat.open();
        } else {
          window.location.href = '/pages/contact';
        }
      });
    });
  };

  window.addEventListener('DOMContentLoaded', initHelpHub);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initHelpHub);
  }
})();
